export const SET_EXPAND_ALL = 'SET_EXPAND_ALL';